"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'project.icon.help': '输入FontAwesome图标类（例如：fas fa-folder）',
};
